import { modelsDir } from './config';

const microbesInfo = {
  koji: {
    id: 0,
    name: 'こうじ菌',
    // text: 'ステージ1で<br><span style="color:#">こうじ菌</span>を<br>たくさんほかくしよう!',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [1],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_1.png'),
    model_path: modelsDir + 'microbe/01_koujikin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '和食ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_1.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_1.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_1.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_1.png'),
    max_count: 8,
  },
  sakusan: {
    id: 1,
    name: '酢酸菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [1],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_2.png'),
    model_path: modelsDir + 'microbe/02_sakusankin.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: 'すっぱハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_2.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_2.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_2.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_2.png'),
    max_count: 8,
  },
  akkermansia: {
    id: 2,
    name: 'アッカーマンシア',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [1],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_3.png'),
    model_path: modelsDir + 'microbe/03_yasekin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_3.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_3.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_3.png'),
    max_count: 4,
  },
  salmonella: {
    id: 3,
    name: 'サルモネラ菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [1],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_4.png'),
    model_path: modelsDir + 'microbe/04_sarumonerakin_3.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_4.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_4.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_4.png'),
    max_count: 4,
  },
  rhodotorula: {
    id: 4,
    name: 'ロドトルラ',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [1],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_5.png'),
    model_path: modelsDir + 'microbe/05_pinkunumerikin_3.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_5.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_5.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_5.png'),
    max_count: 4,
  },
  hosya: {
    id: 5,
    name: '放線菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [2],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_6.png'),
    model_path: modelsDir + 'microbe/06_housenkin.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '抗生物質ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_6.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_6.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_6.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_6.png'),
    max_count: 8,
  },
  penicillium: {
    id: 6,
    name: 'ペニシリウム',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [2],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_7.png'),
    model_path: modelsDir + 'microbe/07_penishiriumu_2.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '奇跡のくすりハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_7.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_7.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_7.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_7.png'),
    max_count: 8,
  },
  euglena: {
    id: 7,
    name: 'ユーグレナ',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [2],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_8.png'),
    model_path: modelsDir + 'microbe/08_yuugurena.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_8.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_8.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_8.png'),
    max_count: 4,
  },
  pankobo: {
    id: 8,
    name: 'パン酵母',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [2],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_9.png'),
    model_path: modelsDir + 'microbe/09_pankoubo.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_9.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_9.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_9.png'),
    max_count: 4,
  },
  kaentake: {
    id: 9,
    name: 'カエンタケ',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [2],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_10.png'),
    model_path: modelsDir + 'microbe/10_kaentake_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_10.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_10.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_10.png'),
    max_count: 4,
  },
  suiso: {
    id: 10,
    name: '水素細菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [3],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_11.png'),
    model_path: modelsDir + 'microbe/11_suisosaikin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: 'CO<sub>2</sub>ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_11.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_11.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_11.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_11.png'),
    max_count: 8,
  },
  labyrinthulea: {
    id: 11,
    name: 'ラビリンチュラ類',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [3],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_12.png'),
    model_path: modelsDir + 'microbe/12_rabirinchura_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: 'アブラ好きハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_12.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_12.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_12.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_12.png'),
    max_count: 8,
  },
  volvox: {
    id: 12,
    name: 'ボルボックス',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [3],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_13.png'),
    model_path: modelsDir + 'microbe/13_borubokkusu_2.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_13.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_13.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_13.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_13.png'),
    max_count: 4,
  },
  thermus: {
    id: 13,
    name: 'サーマス',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [3],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_14.png'),
    model_path: modelsDir + 'microbe/14_saamasu_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_14.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_14.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_14.png'),
    max_count: 4,
  },
  nyusan: {
    id: 14,
    name: '乳酸菌<br />ビフィズス菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [3],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_15.png'),
    model_path: modelsDir + 'microbe/15_nyusankin_bifizusukin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_15.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_15.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_15.png'),
    max_count: 4,
  },
  ideonella: {
    id: 15,
    name: 'イデオネラ<br />（PET分解菌）',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [4],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_16.png'),
    model_path: modelsDir + 'microbe/16_petbunkaikin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: 'PET分解ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_16.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_16.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_16.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_16.png'),
    max_count: 8,
  },
  dehalococcoides: {
    id: 16,
    name: 'デハロコッコイデス',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [4],
    is_correct: true,
    image_path: require('@/assets/images/stage/biseibutsu_icon_17.png'),
    model_path: modelsDir + 'microbe/17_dehairokokkoidesu.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '汚染物質分解ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_17.png'),
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_17.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_17.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_17.png'),
    max_count: 8,
  },
  jisei: {
    id: 17,
    name: '磁性細菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [4],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_18.png'),
    model_path: modelsDir + 'microbe/18_jiseisaikin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_18.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_18.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_18.png'),
    max_count: 4,
  },
  methane: {
    id: 18,
    name: 'メタン菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [4],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_19.png'),
    model_path: modelsDir + 'microbe/19_metankin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_19.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_19.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_19.png'),
    max_count: 4,
  },
  natto: {
    id: 19,
    name: 'なっとう菌',
    text: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
    stage: [4],
    is_correct: false,
    image_path: require('@/assets/images/stage/biseibutsu_icon_20.png'),
    model_path: modelsDir + 'microbe/20_nattoukin_1.gltf',
    model_path_2: modelsDir + 'hammer/hammer.gltf',
    title_name: '',
    title_image_path: '',
    title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_20.png'),
    picture_book_image_path: require('@/assets/images/picturebook/zukan_sp_get_20.png'),
    picture_book_unknown_image_path: require('@/assets/images/picturebook/zukan_sp_unknown_20.png'),
    max_count: 4,
  },  
}

const microbeCatchImages = [
  require('@/assets/images/stage/get_atari.png'),
  require('@/assets/images/stage/get_hazure.png')
]

const microbesStoreVersion = 2;

const microbesStore = {
  koji : {
    id: 0,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  sakusan : {
    id: 1,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  akkermansia : {
    id: 2,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  salmonella : {
    id: 3,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  rhodotorula : {
    id: 4,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  hosya : {
    id: 5,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  penicillium : {
    id: 6,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  euglena : {
    id: 7,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  pankobo : {
    id: 8,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  kaentake : {
    id: 9,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  suiso : {
    id: 10,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  labyrinthulea : {
    id: 11,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  volvox : {
    id: 12,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  thermus : {
    id: 13,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  nyusan : {
    id: 14,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  ideonella : {
    id: 15,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  dehalococcoides : {
    id: 16,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  jisei : {
    id: 17,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  methane : {
    id: 18,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
  natto : {
    id: 19,
    total_count: 0,
    has_title: false,
    is_new: false,
    is_new_title: false,
  },
}

export { microbesInfo, microbeCatchImages, microbesStoreVersion, microbesStore };